__turbopack_context__.v({
  "thumbs-down-cloth": "Icons-module-scss-module__yrwLGG__thumbs-down-cloth",
  "thumbs-down-finger": "Icons-module-scss-module__yrwLGG__thumbs-down-finger",
  "thumbs-up-cloth": "Icons-module-scss-module__yrwLGG__thumbs-up-cloth",
  "thumbs-up-finger": "Icons-module-scss-module__yrwLGG__thumbs-up-finger",
});
